import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { EligibleDiscountList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseEligibleDiscounts {
  productId: string | undefined;
  athleteId?: string;
}

function useEligibleDiscounts({
  productId,
  athleteId,
}: IUseEligibleDiscounts): UseQueryResult<AxiosResponse<EligibleDiscountList[]>> {
  const fetchEligibleDiscounts = useCallback((): Promise<AxiosResponse<EligibleDiscountList[]>> => {
    const params: UrlParams = {};

    if (productId) {
      params.product_id = productId;
    }

    if (athleteId) {
      params.athlete_id = athleteId;
    }

    return client.get(`discounts/eligible_discounts/?${encodeUrlParams(params)}`);
  }, [productId, athleteId]);

  return useQuery(['eligible-discounts', productId, athleteId], fetchEligibleDiscounts, {
    enabled: !!productId,
  });
}

export default useEligibleDiscounts;
